export default __webpack_public_path__ + "static/media/copy.f63ea3a1.svg";